module.exports = __webpack_public_path__ + "img/chip.51deafc1.png";